import { render, staticRenderFns } from "./CardSugerencias.vue?vue&type=template&id=79fc1c37&scoped=true"
import script from "./CardSugerencias.vue?vue&type=script&lang=js"
export * from "./CardSugerencias.vue?vue&type=script&lang=js"
import style0 from "./CardSugerencias.vue?vue&type=style&index=0&id=79fc1c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79fc1c37",
  null
  
)

export default component.exports